import { render } from "./FileBox.vue?vue&type=template&id=7278c8a2"
import script from "./FileBox.vue?vue&type=script&lang=js"
export * from "./FileBox.vue?vue&type=script&lang=js"
script.render = render

export default script